import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import {
  createReportProblemOption,
  updateReportProblemOption,
  deleteReportProblemOption,
  getAllReportProblemAsDataTable,
  getAllReportProblemOptions,
} from './thunks';
import { ReportProblemState } from './types';

export const name = 'reportProblem';

const initialState: ReportProblemState = {
  data: null,
  options: [],
  status: 'idle',
  updatingStatus: 'idle',
  optionStatus: 'idle',
};
// export const answerReportProblemAsync = createAsyncThunk(
//   name + '/answerReportProblem',
//   answerReportProblem
// );
export const createReportProblemOptionAsync = createAsyncThunk(
  name + '/createReportProblemOption',
  createReportProblemOption
);
export const updateReportProblemOptionAsync = createAsyncThunk(
  name + '/updateReportProblemOption',
  updateReportProblemOption
);

export const deleteReportProblemOptionAsync = createAsyncThunk(
  name + '/deleteReportProblemOption',
  deleteReportProblemOption
);
export const getAllReportProblemAsDataTableAsync = createAsyncThunk(
  name + '/getAllReportProblemAsDataTable',
  getAllReportProblemAsDataTable
);
export const getAllReportProblemOptionsAsync = createAsyncThunk(
  name + '/getAllReportProblemOptions',
  getAllReportProblemOptions
);

export const slice = createSlice({
  name: name,
  initialState,
  reducers: {
    clear: (_) => {
      return initialState;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getAllReportProblemAsDataTableAsync.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(
        getAllReportProblemAsDataTableAsync.fulfilled,
        (state, action) => {
          state.status = 'idle';
          state.data = action.payload;
        }
      )
      .addCase(
        getAllReportProblemAsDataTableAsync.rejected,
        (state, action) => {
          state.status = 'failed';
        }
      )
      .addCase(deleteReportProblemOptionAsync.pending, (state) => {
        state.updatingStatus = 'loading';
      })
      .addCase(deleteReportProblemOptionAsync.fulfilled, (state, action) => {
        state.updatingStatus = 'idle';
      })
      .addCase(deleteReportProblemOptionAsync.rejected, (state, action) => {
        state.updatingStatus = 'failed';
      })
      .addCase(createReportProblemOptionAsync.pending, (state) => {
        state.updatingStatus = 'loading';
      })
      .addCase(createReportProblemOptionAsync.fulfilled, (state, action) => {
        state.updatingStatus = 'idle';
      })
      .addCase(createReportProblemOptionAsync.rejected, (state, action) => {
        state.updatingStatus = 'failed';
      })
      .addCase(updateReportProblemOptionAsync.pending, (state) => {
        state.updatingStatus = 'loading';
      })
      .addCase(updateReportProblemOptionAsync.fulfilled, (state, action) => {
        state.updatingStatus = 'idle';
      })
      .addCase(updateReportProblemOptionAsync.rejected, (state, action) => {
        state.updatingStatus = 'failed';
      })
      .addCase(getAllReportProblemOptionsAsync.pending, (state) => {
        state.optionStatus = 'loading';
      })
      .addCase(getAllReportProblemOptionsAsync.fulfilled, (state, action) => {
        state.optionStatus = 'idle';
        state.options = action.payload;
      })
      .addCase(getAllReportProblemOptionsAsync.rejected, (state, action) => {
        state.optionStatus = 'failed';
      });
    // .addCase(answerReportProblemAsync.pending, (state) => {
    //   state.updatingStatus = 'loading';
    // })
    // .addCase(answerReportProblemAsync.fulfilled, (state, action) => {
    //   state.updatingStatus = 'idle';
    // })
    // .addCase(answerReportProblemAsync.rejected, (state, action) => {
    //   state.updatingStatus = 'failed';
    // });
  },
});

export const actions = slice.actions;

export default slice.reducer;
